<template>
  <div class="pop" v-if="popType">
    <div class="popup-bg"></div>
    <div class="popup-container">
      <div style="display: flex; justify-content: space-between; padding: 16px; border-bottom: 1px solid #f5f5f5; font-size: 16px; font-weight: bold">
        <div style="color: #303133; font-size: 18px">常见问题解答</div>
        <div class="close" style="font-weight: 400; font-size: 18px; color: #909399; cursor: pointer" @click="close">x</div>
      </div>
      <div style="max-height: 600px; overflow-y: auto">
        <div class="box" v-for="(item, idx) in contentList" :key="idx">
          <div class="content-between content" style="margin: 32px 48px 0 24px" @click="showContent(item)">
            <div class="flex">
              <div class="div-q">Q</div>
              <div class="div-content">{{ item.wt.content }}</div>
            </div>
            <div class="arrow-top" v-if="item.da.show"></div>
            <div class="arrow-bottom" v-else></div>
          </div>
          <div class="content-between content2" v-if="item.da.show" style="margin: 16px 48px 0 24px">
            <div style="width: 100%">
              <div class="flex">
                <div class="div-q" style="background: #d1ddff; color: #333">A</div>
                <div class="div-content">{{ item.da.content }}</div>
              </div>
              <div v-if="item.da.img" class="content-center" style="margin-top: 10px">
                <img width="600px" :src="item.da.img" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="btn-group">
        <div class="btn btn1" @click="close">取消</div>
        <!-- <div class="btn btn2" @click="enter">确认退出</div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { oss_url_common } from '@/utils'
import { openQQ } from '@/utils/functions'

export default {
  name: 'Popup',
  props: {
    popType: Boolean
  },
  data() {
    return {
      oss_url_common,
      isMove: false,
      right: '10px',
      bottom: '131px',
      contentList: []
    }
  },
  mounted() {
    this.getContent()
  },
  methods: {
    getContent() {
      this.contentList = [
        {
          wt: {
            content: '怎么查看收费明细？'
          },
          da: {
            content: '您好，具体请见以下图片内容',
            show: false,
            img: 'https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/official/fourth_year.png'
          }
        },
        {
          wt: {
            content: '怎么开发票？'
          },
          da: {
            content: '您好，如充值到我司上海抬头账户可用管理员账号线上申请开票，具体请见以下流程（附开票申请流程图片），如充值到我司杭州抬头账户的请联系我司客服线下申请开发票',
            show: false,
            img: 'https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/eline/kplc.jpg'
          }
        },
        {
          wt: {
            content: '用户怎么认证？怎么加入企业？'
          },
          da: {
            content: '具体请见附件流程图片',
            show: false,
            img: 'https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/eline/qyrz.jpg'
          }
        },
        {
          wt: {
            content: '大连舱单可以发送吗？'
          },
          da: {
            content: '不可以，目前支持上海、青岛、海外舱单发送',
            show: false
          }
        }
      ]

      // let a ='/cps/'
      if (location.pathname == '/em/') {
        this.contentList = [
          {
            wt: {
              content: '麻烦给我一下EM的文件'
            },
            da: {
              content: '若新发的EM，在发送记录找到对应的单号，选择"EM PDF导出"和“close 导出，若改过单的EM，在改单记录找到对应的单号，选择"EM PDF导出"和“close 导出”',
              show: false
            }
          },
          {
            wt: {
              content: 'EM的分单号错了，现在怎么处理/操作？'
            },
            da: {
              content: '不可以哦，分单号/货代单号错了只能删单重发，其余信息更改均可以改单',
              show: false
            }
          },
          {
            wt: {
              content: '什么情况申报EM/ACI？'
            },
            da: {
              content: '货物经过加拿大港口不下船，发送ACI，运输类型为FROB；货物经加拿大内陆转运到美国，发送EM和ACI均可，运输类型为In-transit；其他情况，需要发送EM。',
              show: false
            }
          },
          {
            wt: {
              content: '我的EM上层是否匹配？'
            },
            da: {
              content: '请核实上层是否已发，单号，柜封号等信息是否准确，若无误，请在系统查询匹配状态',
              show: false
            }
          },
          {
            wt: {
              content: '我的EM下层是否匹配？'
            },
            da: {
              content: '请核实是否有下层，下层EM是否已发，单号，柜封号等信息是否准确，若无误，请在系统查询匹配状态',
              show: false
            }
          },
          {
            wt: {
              content: 'EM&ACI:船东提单号船东提单号，船东提单中的四位SCAC CODE需要加吗？'
            },
            da: {
              content: '每个船公司出提单时，都有自己的四位code，像HLCU这种，EM和ACI里面船东有另外的9000CODE，船东原有的code像SMLM这种，有的船公司需要加，有的不需要。按照我们的经验，ONEY,HLCU，HDMU,SMLM，EGLV，OOLU，CMDU，这些不用加；ZIMU，SUDU，COSU需要加。',
              show: false
            }
          },
          {
            wt: {
              content: 'EM&ACI: 运输类型怎么选，目的港清关，内陆点清关 还有啥转运的？'
            },
            da: {
              content: '进口至加拿大，并且将货物运输到内陆清关时，选择in-bond；另外一种进口至加拿大且在FPOA到达后的第一个港口清关的货物，选择import;经过加拿大内陆转运到美国，比如王子港卸船，铁路到芝加哥，选in-transit。',
              show: false
            }
          },
          {
            wt: {
              content: 'EM为啥改单（删单）了，系统还是没有更新？'
            },
            da: {
              content: '提交了改单（删单）的，请前往改单（删单）记录查看，不会覆盖原始的发送记录的',
              show: false
            }
          },
          {
            wt: {
              content: 'EM分单号/货代单号错了只能删单重发？'
            },
            da: {
              content: '不可以哦，分单号/货代单号错了只能删单重发，其余信息更改均可以改单',
              show: false
            }
          },
          {
            wt: {
              content: 'EM&ACI:我司8000CODE是什么'
            },
            da: {
              content: '8FTH，ACI和EM相同，需要在订舱或者补料时提交船司；如果船司说不需要，也可以不提交',
              show: false
            }
          },
          {
            wt: {
              content: 'EM&ACI: 9000 code和8000 code有什么区别'
            },
            da: {
              content: '8000code是货代在加拿大海关的code，9000是船公司在加拿大海关的code',
              show: false
            }
          },
          {
            wt: {
              content: '我们只有海单/M单，你们能帮忙代发吗？'
            },
            da: {
              content: 'M单的ACI/EM船东会整船发送，不需要货代自己发。我司提供的是H单ACI/EM发送平台',
              show: false
            }
          },
          {
            wt: {
              content: 'EM是每层提单都要发吗？'
            },
            da: {
              content: '是的，要是套单，每一层都需要发，且层层关联、层层匹配。这是新版EM和旧ACI系统最大的不同',
              show: false
            }
          },
          {
            wt: {
              content: 'EM&ACI: 支持所有船公司发送吗？'
            },
            da: {
              content: 'EM/ACI不限船司，如果发现想发的船公司找不到，可以联系客服添加',
              show: false
            }
          },
          {
            wt: {
              content: 'EM:我们这票货是散货，走其他拼箱公司，船东提单号到底是船公司出具给拼箱公司的提单号，还是说拼箱公司的提单号？'
            },
            da: {
              content: '船东提单号，就是船公司出具给拼箱公司的提单号。拼箱公司的提单号填写在【上一层货代提单号】一栏中',
              show: false
            }
          },
          {
            wt: {
              content: 'EM:我发的是直客信息 我的上一层是MBL，怎么申报'
            },
            da: {
              content: '如果发的是直客信息的，下一层提单这里选否。上一层是M单，也就是说没有同行订舱口给你们签发HBL，那左边选MBL,上一层货代提单号空着',
              show: false
            }
          },
          {
            wt: {
              content: 'EMF怎么改单？'
            },
            da: {
              content: '1.若还未发CLOSE，请在发送记录直接提交改单\n2.若之前有改过单，请继续在改单记录进行改单\n3.若CLOSE已接收成功了，先删CLOSE，等CLOSE删成功，再提交改单，等改成功，你再进去重发下CLOSE',
              show: false
            }
          },
          {
            wt: {
              content: 'EMF怎么删单？'
            },
            da: {
              content: '1.若还未发CLOSE，请在发送记录直接提交删单\n2.若之前有改过单，请在改单记录提交删单\n3.若CLOSE已接收成功了，先删CLOSE，等CLOSE删成功，再提交删单',
              show: false
            }
          },
          {
            wt: {
              content: '可以同时发ACI和EM吗'
            },
            da: {
              content: '不可以，em和Aci是一种类型的，只能发一个，不能重复提交',
              show: false
            }
          },
          {
            wt: {
              content: '什么是申报EM?'
            },
            da: {
              content: 'EMF，即eManifest，也叫EMF、eHBL、ACI eHBL、ACI eManifest。 EM是原ACI的升级系统，船东申报M单EM，货代申报H单EM，且每一层H单都需要申报，层层关联。通过ACI eManifest可以发送海运、空运、铁运和公路运输的子舱单。',
              show: false
            }
          },
          {
            wt: {
              content: '这个海外舱单EM的过境条款该怎么填啊？'
            },
            da: {
              content:
                'Import/In-bond 都是进口到加拿大的货物，按照下列对应的实际情况来做选择：\n1.import是在入境加拿大的第一个港口就必须卸货清关。\n2.in-bond是在加拿大的港口卸货，拉到内陆的指定仓库做清关\n3.In-transit 是过境加拿大，在加拿大港口卸货以后，通过陆运进口到美国的，只是过境，货物不在加拿大销售，所以不需要清关交税',
              show: false
            }
          },
          {
            wt: {
              content: 'EM:怎么理解有下一层提单？'
            },
            da: {
              content: '有下一层提单指的是，你现在发的这份EM的提单上发货人不是真实shipper，是货代',
              show: false
            }
          },
          {
            wt: {
              content: 'EM&ACI: 目的港/卸货港怎么填？'
            },
            da: {
              content:
                '目的港：Place of Destination，port of final release in Canada，在加拿大的最后一个地方。\n目的港仓库代码：Sub-Location of Destination，问订舱口或目的港代理。\n卸货港：Port of discharge/arrival，port of first entry to Canada，进入加拿大第一卸港。\n卸货港仓库代码：Sub-Location of Discharge，问订舱口或目的港代理',
              show: false
            }
          },
          {
            wt: {
              content: 'EM&ACI: 仓库代码是啥，怎么填？'
            },
            da: {
              content: '仓库代码，即sub-location code是EM里的新要求。卸货港代码，仓库代码需要找船公司确认核实哦',
              show: false
            }
          }
        ]
      }

      if (location.pathname == '/aci/') {
        this.contentList = [
          {
            wt: {
              content: 'ACI怎么改单/删单？'
            },
            da: {
              content: '1.若未接收成功，请等接收成功后再进行改单/删单操作\n2.若已接收成功，请在发送记录直接提交改单/删单\n3.若之前有改过单，请在改单记录提交改单/删单',
              show: false
            }
          },
          {
            wt: {
              content: '什么情况申报EM/ACI？'
            },
            da: {
              content: '货物经过加拿大港口不下船，发送ACI，运输类型为FROB；货物经加拿大内陆转运到美国，发送EM和ACI均可，运输类型为In-transit；其他情况，需要发送EM。',
              show: false
            }
          },
          {
            wt: {
              content: '这条船（单号）不靠VAN/温哥华,现在要怎么处理/操作？'
            },
            da: {
              content: '请在系统上发送记录找到这单并提交删单申请',
              show: false
            }
          },
          {
            wt: {
              content: 'EM&ACI:船东提单号船东提单号，船东提单中的四位SCAC CODE需要加吗？'
            },
            da: {
              content: '每个船公司出提单时，都有自己的四位code，像HLCU这种，EM和ACI里面船东有另外的9000CODE，船东原有的code像SMLM这种，有的船公司需要加，有的不需要。按照我们的经验，ONEY,HLCU，HDMU,SMLM，EGLV，OOLU，CMDU，这些不用加；ZIMU，SUDU，COSU需要加。',
              show: false
            }
          },
          {
            wt: {
              content: 'EM&ACI: 运输类型怎么选，目的港清关，内陆点清关 还有啥转运的？'
            },
            da: {
              content: '进口至加拿大，并且将货物运输到内陆清关时，选择in-bond；另外一种进口至加拿大且在FPOA到达后的第一个港口清关的货物，选择import;经过加拿大内陆转运到美国，比如王子港卸船，铁路到芝加哥，选in-transit。',
              show: false
            }
          },
          {
            wt: {
              content: 'EM&ACI: 仓库代码是啥，怎么填？'
            },
            da: {
              content: '仓库代码，即sub-location code是EM里的新要求。卸货港代码，仓库代码需要找船公司确认核实哦',
              show: false
            }
          },
          {
            wt: {
              content: 'ACI分单号/货代单号错了只能删单重发？'
            },
            da: {
              content: '不可以哦，分单号/货代单号错了只能删单重发，其余信息更改均可以改单',
              show: false
            }
          },
          {
            wt: {
              content: 'ACI为啥改单（删单）了，系统还是没有更新？'
            },
            da: {
              content: '提交了改单（删单）的，请前往改单（删单）记录查看，不会覆盖原始的发送记录的',
              show: false
            }
          },
          {
            wt: {
              content: 'ACI的分单号错了，现在怎么处理/操作？'
            },
            da: {
              content: '不可以哦，分单号/货代单号错了只能删单重发，其余信息更改均可以改单',
              show: false
            }
          },
          {
            wt: {
              content: 'EM&ACI:我司8000CODE是什么？'
            },
            da: {
              content: '8FTH，ACI和EM相同，需要在订舱或者补料时提交船司；如果船司说不需要，也可以不提交',
              show: false
            }
          },
          {
            wt: {
              content: 'EM&ACI: 9000 code和8000 code有什么区别？'
            },
            da: {
              content: '8000code是货代在加拿大海关的code，9000是船公司在加拿大海关的code',
              show: false
            }
          },
          {
            wt: {
              content: 'EM&ACI: 我们只有海单/M单，你们能帮忙代发吗？'
            },
            da: {
              content: 'M单的ACI/EM船东会整船发送，不需要货代自己发。我司提供的是H单ACI/EM发送平台',
              show: false
            }
          },
          {
            wt: {
              content: 'EM&ACI: 支持所有船公司发送吗？'
            },
            da: {
              content: 'EM/ACI不限船司，如果发现想发的船公司找不到，可以联系客服添加',
              show: false
            }
          },
          {
            wt: {
              content: '我可以用自己的CODE发送ACI吗？'
            },
            da: {
              content: '可以的，绑定自有code 一般需要2-5个工作日左右。需要用户提供ACI申请表',
              show: false
            }
          },
          {
            wt: {
              content: '可以同时发ACI和EM吗？'
            },
            da: {
              content: '不可以，em和Aci是一种类型的，只能发一个，不能重复提交',
              show: false
            }
          },
          {
            wt: {
              content: '什么是申报ACI?'
            },
            da: {
              content: 'ACI(Advance Commercial Information)是预申报商业信息系统，即加拿大版本的AMS舱单系统，所有进口或过境加拿大的货物都要申报ACI',
              show: false
            }
          },
          {
            wt: {
              content: 'ACI的运输条款怎么选择？'
            },
            da: {
              content: '1.FROB-货物经过加拿大港口不下船\n2.In-transit-货物经加拿大内陆转运到其他地方',
              show: false
            }
          },
          {
            wt: {
              content: 'EM&ACI: 目的港/卸货港怎么填？'
            },
            da: {
              content:
                '目的港：Place of Destination，port of final release in Canada，在加拿大的最后一个地方。\n目的港仓库代码：Sub-Location of Destination，问订舱口或目的港代理。\n卸货港：Port of discharge/arrival，port of first entry to Canada，进入加拿大第一卸港。\n卸货港仓库代码：Sub-Location of Discharge，问订舱口或目的港代理',
              show: false
            }
          }
        ]
      }
      if (location.pathname == '/ams/') {
        this.contentList = [
          {
            wt: {
              content: 'AMS什么是1Y 3Z？'
            },
            da: {
              content: '1Y，和船东单匹配成功，3Z，和ISF匹配成功',
              show: false
            }
          },
          {
            wt: {
              content: 'AMS的分单号错了，现在怎么处理/操作？'
            },
            da: {
              content: '不可以哦，分单号/货代单号错了只能删单重发，其余信息更改均可以改单',
              show: false
            }
          },
          {
            wt: {
              content: '我这票有没有1Y 3Z或是没有匹配--AMS？'
            },
            da: {
              content: '1.麻烦看下这票是否有改单操作，改单后，在改单记录看匹配状态\n2.请核实船东是否已发，已发后，系统会自动匹配的',
              show: false
            }
          },
          {
            wt: {
              content: '墨西哥的AMS你们可以发吗？'
            },
            da: {
              content: '不可以，墨西哥的AMS都是船东发的',
              show: false
            }
          },
          {
            wt: {
              content: '请问你们8000的code或是AMS SCAC CODE提供下'
            },
            da: {
              content: 'ACI & EM 8000 CODE:8FTH\nAMS SCAC CODE:IMXN',
              show: false
            }
          },
          {
            wt: {
              content: 'AMS怎么改单/删单？'
            },
            da: {
              content: '1.若未接收成功，请等接收成功后再进行改单/删单操作\n2.若已接收成功，请在发送记录直接提交改单/删单\n3.若之前有改过单，请在改单记录提交改单/删单',
              show: false
            }
          },
          {
            wt: {
              content: '我这个柜子甩柜/换船了，AMS/AFR 需要更新一下系统吗?'
            },
            da: {
              content: '换船了的话，请提交下改单哈',
              show: false
            }
          },
          {
            wt: {
              content: 'AMS的中转港怎么显示？'
            },
            da: {
              content: '显示为进入美国的最后一个外国港口，为非美国港口',
              show: false
            }
          },
          {
            wt: {
              content: '我可以用自己的CODE发送AMS吗？'
            },
            da: {
              content: '可以的，绑定自有code，一般需要2-5个工作日。需要用户提供以下资料：针对AMS----SCAC证书，C3 bond，FMC bond。 并填写绑定申请表。',
              show: false
            }
          },
          {
            wt: {
              content: 'AMS为啥改单（删单）了，系统还是没有更新？'
            },
            da: {
              content: '提交了改单（删单）的，请前往改单（删单）记录查看，不会覆盖原始的发送记录的',
              show: false
            }
          },
          {
            wt: {
              content: 'AMS分单号/货代单号错了只能删单重发？'
            },
            da: {
              content: '不可以哦，分单号/货代单号错了只能删单重发，其余信息更改均可以改单',
              show: false
            }
          },
          {
            wt: {
              content: '什么是申报AMS?'
            },
            da: {
              content: 'AMS全称是America manifest system，即美国仓单系统。 货代必须于开船之前48小时把货物等资料报给承运人，承运人必须于开船之前24小时将货物资料通过AMS系统报美国海关，必须向美国海关提供真正的货主和收货人。',
              show: false
            }
          },
          {
            wt: {
              content: '如果美国到加拿大发的AMS，ISF5+2，这样的情况下回匹配3Z吗？'
            },
            da: {
              content: '会匹配3Z',
              show: false
            }
          },
          {
            wt: {
              content: '发送AMS的时候， HBL超长要怎么处理？'
            },
            da: {
              content: '您好，AMS的HBL单号只支持12位哦',
              show: false
            }
          }
        ]
      }
      if (location.pathname == '/afr/') {
        this.contentList = [
          {
            wt: {
              content: 'AFR为啥改单（删单）了，系统还是没有更新？'
            },
            da: {
              content: '提交了改单（删单）的，请前往改单（删单）记录查看，不会覆盖原始的发送记录的',
              show: false
            }
          },
          {
            wt: {
              content: 'AFR的分单号错了，现在怎么处理/操作？'
            },
            da: {
              content: '不可以哦，分单号/货代单号错了只能删单重发，其余信息更改均可以改单',
              show: false
            }
          },
          {
            wt: {
              content: 'AFR分单号/货代单号错了只能删单重发？'
            },
            da: {
              content: '不可以哦，分单号/货代单号错了只能删单重发，其余信息更改均可以改单',
              show: false
            }
          },
          {
            wt: {
              content: '什么是申报AFR?'
            },
            da: {
              content: 'AFR的正式名称是Advance Filing Rules on Maritime Container Cargo Information。对于计划进入日本港口的船舶上装载的集装箱货物，船公司或无船承运人原则上必须在船舶离开境外装船港24小时前，以电子数据形式向日本海关预先申报集装箱货物的舱单资料,也即预申报制度。（PS:AFR也可以补发）',
              show: false
            }
          },
          {
            wt: {
              content: '你们可以发AFR(AHR)或者AMS,ACI,EM吗？'
            },
            da: {
              content: '支持发送，在系统里的“数据发送”找到对应的AFR或者AMS,ACI,EMF，船公司发的是主单M/L，我司系统只能发是分单H/L',
              show: false
            }
          },
          {
            wt: {
              content: '你们发AFR(AHR)或者AMS,ACI,EMF怎么发送？'
            },
            da: {
              content: '支持表格导入和在线手动输入，在“草稿箱”里有表格导入，点击“表格导入”，最后点击“下载模板”既可：\nAFR SCAC code ：J7D7 \nACI & EM 8000 CODE:8FTH.\nAMS SCAC CODE:IMXN',
              show: false
            }
          },
          {
            wt: {
              content: 'AFR修改了二程船信息 ，AMS,EM,ACI船公司M单号提交错误，数据提交错误，修改箱型封号等怎么操作？'
            },
            da: {
              content: '请在平台上找到对应的此票提交改单申请即可。',
              show: false
            }
          },
          {
            wt: {
              content: 'AFR收货人可以发TO ORDER吗？'
            },
            da: {
              content: '日本AFR中的收货人可以只填写TO ORDER。但需要你的通知人的信息为正确的,以下具体要求：1>通知人的名称、地址和电话信息必须为真实有效的。2>收货人的名称和地址信息请填写为 TO ORDER，收货人的国别代码和电话，请填写与通知人的一致。',
              show: false
            }
          },
          {
            wt: {
              content: '拼箱如何发AFR？'
            },
            da: {
              content: '拼箱的情况下，请先核实是否有出分单，若未出分单，则由直接由船司申报主单的AFR即可，若出多票分单，请根据对应的分单数申报AHR，如出两票分单，则申报2票AHR',
              show: false
            }
          }
          // {
          //   wt: {
          //     content:'一票有多个货物时如何填写HSCode和品名（一份AFR舱单中,只有允许填写一个HS Code和一个商品描述信息.那么,我一票House BL单中有多个货物时应该如何申报？）'
          //   },
          //   da: {
          //     content:'1Y，和船东单匹配成功，3Z，和ISF匹配成功',
          //     show: false
          //   },
          // }
        ]
      }
      // if(location.pathname == '/isf/') {
      //   this.contentList = [{
      //     wt: {
      //       content:'AFR，AMS，ACI,EM为啥改单（删单）了，系统还是没有更新？'
      //     },
      //     da: {
      //       content:'提交了改单（删单）的，请前往改单（删单）记录查看，不会覆盖原始的发送记录的',
      //       show: false
      //     },
      //   },]
      // }
      // if(a == '/cps/') {
      if (location.pathname == '/cps/') {
        this.contentList = [
          {
            wt: {
              content: '提单号XXX船名航次XXX船公司XXX帮忙看看船代？（上海舱单）'
            },
            da: {
              content: '上海舱单查询方式：通过1港通网址https://booking.1gangtong.com/WebManifest/Schedule/CutScheduleQuery?TEMPDATAID=E44K0L9M0V7R633LE 输入正确的航次查询船代，如查询失败，请联系客服进行处理！',
              show: false
            }
          },
          {
            wt: {
              content: '预配舱单框架箱/特种箱没有封号怎么填写？'
            },
            da: {
              content: '您好，上海预配舱单框架箱/特种箱没有封号请填写NONE',
              show: false
            }
          },
          {
            wt: {
              content: '上海舱单如何提交改单？'
            },
            da: {
              content: '您好，上海舱单，请在已发送模块里搜索该提单号，然后勾选要修改的提单号，点击改单按钮进入页面进行修改正确的数据，保存后点击修改报文按钮进行发送',
              show: false
            }
          },
          {
            wt: {
              content: '上海舱单如何提交删单？'
            },
            da: {
              content:
                '1.您好，上海舱单，请在已发送模块里搜索该提单号，然后勾选要删除的提单号，点击删单按钮进行提交\n2.提交舱单删除报文前，请确认若需要删除拼箱舱单，请同时删除该箱号下所有舱单，否则会导致删除失败，且费用不退回！\n3.本次删除的舱单均未报关：若已报关，但在自由变更时间内，请删除报关单后，线上删除本舱单；若已报关，且已超过自由变更时间，请联系客服进行柜台删单；',
              show: false
            }
          },
          {
            wt: {
              content: '上海舱单箱号、封号、箱型、船名、航次、提单号、船公司、船代、品名数据错误，在系统如何操作？'
            },
            da: {
              content:
                '1.其中一项数据错误，请在系统提交删单申请，提交舱单删除报文前，请确认\n1.若需要删除拼箱舱单，请同时删除该箱号下所有舱单，否则会导致删除失败\n2.本次删除的舱单均未报关：\n若已报关，但在自由变更时间内，请删除报关单后，线上删除本舱单；\n若已报关，且已超过自由变更时间，请联系客服进行柜台删单；',
              show: false
            }
          },
          {
            wt: {
              content: '上海舱单件数、毛重、体积、收货人、发货人、通知人数据错误，在系统如何操作？'
            },
            da: {
              content: '其中一项数据错误，请在系统提交改单申请 改单需同时满足以下3种条件，海关才会接受更改申请：\n1.你想修改的舱单海关已经回执；\n2.货物尚未报关，舱单尚未被报关核注；\n3.装船前24小时以上',
              show: false
            }
          },
          {
            wt: {
              content: '拼箱的舱单已报关，同一个箱子还能加拼一个提单号发送吗？'
            },
            da: {
              content: '上海舱单，若箱子里的其他任意一票舱单已提运单放行，则不允许加拼，若未提运单放行，则允许加拼发送',
              show: false
            }
          },
          {
            wt: {
              content: '舱单报关了，可以变更数据吗？'
            },
            da: {
              content: '您好，上海舱单报关后不允许变更所有数据，请删除报关单后再进行改单、删单申请（若已超过自由变更时间，请联系客服进行柜台删单）',
              show: false
            }
          },
          {
            wt: {
              content: '同箱子拼票舱单，其中一个提单号下的箱封号错了，可以在系统里提交这票错误提单号删单申请吗？'
            },
            da: {
              content: '您好，上海舱单根据海关规定，同箱子下的所有提单号必须同时提交删单申请，在系统中勾选其中一票同箱子的提单号提交删单申请，系统默认把该单箱子下相关联的提单号一并带出进行删单申请',
              show: false
            }
          },
          {
            wt: {
              content: '11104 舱单运输工具无预报动态，海关审核不通过。\n21102 舱单运输工具未备案，海关审核不通过。\n本航次还没开始发送，请联系操作！\n舱单运输工具无预报动态，海关审核不通过。'
            },
            da: {
              content: '上海舱单回执状态提示该状态，表示船舶未备案，等船舶备案好，系统将会自动发送，请勿再次提交（除鹏海船代外）',
              show: false
            }
          }
        ]
      }
      if (location.pathname == '/cpsqd/') {
        this.contentList = [
          {
            wt: {
              content: '提单号XXX船名航次XXX船公司XXX帮忙看看船代？（上海舱单）'
            },
            da: {
              content: '目前青岛舱单小船东太多无法查询精准的船代，只能通过订舱代理确认船代',
              show: false
            }
          },
          {
            wt: {
              content: '预配舱单框架箱/特种箱没有封号怎么填写？'
            },
            da: {
              content: '您好，青岛预配舱单框架箱/特种箱没有封号请填写NONE',
              show: false
            }
          },
          {
            wt: {
              content: '预配舱单卸货港/目的港系统搜索不到对应的五字码怎么办？'
            },
            da: {
              content: '您好，青岛舱单请联系客服进行人工处理',
              show: false
            }
          },
          {
            wt: {
              content: '拼箱的舱单已报关，同一个箱子还能加拼一个提单号发送吗？'
            },
            da: {
              content: '您好，青岛舱单不允许',
              show: false
            }
          },
          {
            wt: {
              content: '舱单报关了，可以变更数据吗？'
            },
            da: {
              content: '您好，青岛舱单报关后不允许变更所有数据，请删除报关单后再进行改单',
              show: false
            }
          },
          {
            wt: {
              content: '同箱子拼票舱单，其中一个提单号下的箱封号错了，可以在系统里提交这票错误提单号删单申请吗？'
            },
            da: {
              content: '您好，青岛舱单若需要删除拼箱舱单，请先提交分单号再提交主单号进行删单操作',
              show: false
            }
          },
          {
            wt: {
              content: '青岛舱单舱单如何提交改单？'
            },
            da: {
              content: '青岛舱单，请在已发送模块里搜索该提单号，然后勾选要修改的提单号，点击改单按钮进入页面进行修改正确的数据（注意：青岛舱单改单需先提交主单号再提交分单号进行改单，如主单号数据正确，分单号错误情况下提交分单号改单即可）',
              show: false
            }
          },
          {
            wt: {
              content: '青岛舱单舱单如何提交删单？'
            },
            da: {
              content: '青岛舱单，请在已发送模块里搜索该提单号，然后勾选要删除的提单号，点击删单按钮进行提交（注意：青岛舱单删单操作请先提交分单号再提交主单号进行删单操作）',
              show: false
            }
          },
          {
            wt: {
              content: '青岛舱单箱号、封号、箱型、船名、航次、提单号、船公司、船代数据错误，在系统如何操作？'
            },
            da: {
              content: '其中一项数据错误，请在系统提交删单申请，提交舱单删除报文前，请确认\n1.若需要删除拼箱舱单，请先提交分单号再提交主单号进行删单操作，否则会导致删除失败！\n2.本次删除的舱单均未报关：\n若已报关，请删除报关单后，线上删除本舱单；',
              show: false
            }
          },
          {
            wt: {
              content: '青岛舱单件数、毛重、体积、收货人、发货人、品名、通知人数据错误，在系统如何操作？'
            },
            da: {
              content:
                '其中一项数据错误，请在系统提交改单申请 改单需同时满足以下3种条件，海关才会接受更改申请：\n1.你想修改的舱单海关已经回执；（注意：青岛舱单改单需先提交主单号再提交分单号进行改单，如主单号数据正确，分单号错误情况下提交分单号改单即可）\n2.货物尚未报关，舱单尚未被报关核注；\n3.装船前24小时以上',
              show: false
            }
          },
          {
            wt: {
              content: '11104 舱单运输工具无预报动态，海关审核不通过。\n21102 舱单运输工具未备案，海关审核不通过。\n本航次还没开始发送，请联系操作！\n舱单运输工具无预报动态，海关审核不通过。'
            },
            da: {
              content: '青岛舱单回执状态提示该状态，表示船舶未备案，等船舶备案好，系统将会自动发送，请勿再次提交',
              show: false
            }
          },
          {
            wt: {
              content: '舱单发送出去，还可以撤回、取消吗？'
            },
            da: {
              content: '舱单一旦点击发送按钮后无法取消，请在发送前确认好数据，避免发错产生不必要费用',
              show: false
            }
          },
          {
            wt: {
              content: '青岛舱单主单已发，分单可以后补吗？'
            },
            da: {
              content: '可以的，但分单号的数据必须与主单号总和数据一致，（避免数据填写错误，最好一并发送）',
              show: false
            }
          },
          {
            wt: {
              content: '船公司通知统一换船，船代不变 ，且同一关区，舱单帮忙改下，需要改配到另一条船'
            },
            da: {
              content:
                '青岛舱单换船改配的：\n1.已报关放行的，看新船是否在同一关区，如在同一关区：请在平台上“已发送记录”中-勾选需要改配的单子 - 点击“改配”- 填好改配需要的相应信息-最后点击“确定”即可。\n2.未放行已刷卡和已放行不在同一关区的，删除报关单后请联系客服删除舱单；\n3.未报关的舱单，直接在平台上“已发送记录”中提交“删除”，等预配舱单删除成功后，点击“复制”此票，修改为正确的船名航次后，点保存，再发送即可。',
              show: false
            }
          },
          {
            wt: {
              content: '青岛舱单主单、分单号怎么发送？'
            },
            da: {
              content: '青岛舱单是N+1模式发单子：\n1.单票的话，主单一票进行发送(费用按单票主单费用来收取)\n2. 2票报关是主单+2票分单舱单进行发送',
              show: false
            }
          },
          {
            wt: {
              content: '青岛舱单无预报是什么意思？'
            },
            da: {
              content: '无预报：是船期还早，一般船开前3天船舶就会备案好，等备案后平台系统会自动重发，等待舱单回执即可。',
              show: false
            }
          }
        ]
      }
      if (location.pathname == '/vgm/') {
        this.contentList = [
          {
            wt: {
              content: '请问2个箱子，分别对应主单号和加拼单号，发加拼单号的时候，vgm里面的提单号用主单号还是加拼？'
            },
            da: {
              content: '拼票的舱单发送VGM时，请用SO里的主提单号进行操作发，切勿用分单号进行发送，避免船公司接收不到VGM数据',
              show: false
            }
          },
          {
            wt: {
              content: '你们舱单、VGM是怎么收费的？'
            },
            da: {
              content: '上海舱单：原始发送25元/提单号 正常改单35元/提单号 正常删单35元/提单号 青岛舱单：原始发送主提单号/35元 分单号/25元 VGM：5元/箱',
              show: false
            }
          },
          {
            wt: {
              content: 'VGM可以删除、修改、重复发吗？'
            },
            da: {
              content: 'VGM没有删改功能，只能重新发送，VGM重发会覆盖掉之前发送的数据',
              show: false
            }
          },
          {
            wt: {
              content: 'MCC可以发舱单和VGM吗？'
            },
            da: {
              content: '1.您好，请问是上海舱单还是青岛舱单？\n2.上海舱单发舱单时选择MSK/MCC船司即可，发VGM请单独选择MCC船司\n3.青岛舱单请单独选择MCC船司，VGM请选择MCC/SEALAND—海陆马士基船司',
              show: false
            }
          },
          {
            wt: {
              content: 'VGM怎么修改删除？'
            },
            da: {
              content: '无论上海舱单还是青岛舱单，VGM都没有删除和修改，如需更新请重发覆盖即可',
              show: false
            }
          },
          {
            wt: {
              content: 'VGM发送回执失败也扣费吗？'
            },
            da: {
              content: 'VGM发送就会产生传输费，请联系客服查询失败原因',
              show: false
            }
          }
        ]
      }

      // if(location.pathname == '/') return true
    },
    showContent(v) {
      v.da.show = !v.da.show
    },
    close() {
      this.$emit('close')
    },
    enter() {
      this.$emit('enter')
    },
    handleClick() {
      if (!this.isMove) {
        openQQ()
      }
    },
    getPostion() {
      let position = localStorage.getItem('ContactQQPostion')
      if (!position) return
      let arr = position.split(',')
      if (arr.length !== 2) return
      this.right = arr[0]
      this.bottom = arr[1]
    }
  }
}
</script>

<style lang="scss" scoped>
// flex 左右
.content-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.content-center {
  display: flex;
  justify-content: center;
  align-items: center;
}
.content:hover {
  cursor: pointer;
  .arrow-bottom {
    border-color: #1170eb;
  }
  .arrow-top {
    border-color: #1170eb;
  }
}

.arrow-top {
  width: 10px;
  height: 10px;
  background-color: transparent; /* 模块背景为透明 */
  border-color: #999;
  border-style: solid;
  border-width: 2px 2px 0 0;
  transform: rotate(-45deg); /*箭头方向可以自由切换角度*/
}
.arrow-bottom {
  width: 10px;
  height: 10px;
  background-color: transparent; /* 模块背景为透明 */
  border-color: #999;
  border-style: solid;
  border-width: 2px 2px 0 0;
  transform: rotate(135deg); /*箭头方向可以自由切换角度*/
}
.flex {
  display: flex;
}
.div-q {
  min-width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  background: #1170eb;
  border-radius: 5px;

  font-size: 13px;
  font-family: Helvetica;
  color: #ffffff;
  margin-right: 16px;
}
.div-content {
  // height: 20px;
  font-size: 14px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 20px;
  white-space: break-spaces;

  user-select: auto !important;
  -webkit-touch-callout: none !important;
  -webkit-tap-highlight-color: transparent !important;
}
.pop {
  position: absolute;
  z-index: 999;
  height: 100%;
}

.pop .popup-bg {
  background-color: rgba(0, 0, 0, 0.3);
  position: fixed;
  width: 100%;
  left: 0;
  top: 0;
  height: 100%;
  z-index: 1;
}

.pop .popup-container {
  position: fixed;
  width: 1200px;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  z-index: 2;
  background: white;
  border-radius: 10px;
}

.pop .popup-container .btn-group {
  display: flex;
  justify-content: right;
  // padding-top: 40px;
  margin: 24px;
  float: right;
}

.pop .popup-container .btn-group .btn {
  flex-shrink: 0;
  flex: 1;
  max-width: 55px;
  min-width: 55px;
  min-height: 31px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  font-size: 12px;
}

.pop .popup-container .btn-group .btn:first-child {
  cursor: pointer;
  background: #fff;
  border: 1px solid #dcdfe6;
  color: #606266;
  max-height: 31px;
  margin-right: 10px;
}
.btn-group {
  .btn1:hover {
    background: #ecf5ff !important;
    border: 1px solid #c6e2ff !important;
    color: #409eff !important;
  }
  .btn2:hover {
    background: #79bbff !important;
    border: 1px solid #79bbff !important;
    color: #fff !important;
  }
  .btn2 {
    min-width: 80px !important;
  }
}

// .pop .popup-container .btn-group .btn:last-child {
//   cursor: pointer;
// 	color: #fff;
// 	background-color: #409eff;
// 	border: 1px solid #409eff;

// 	max-height: 31px;

// }
</style>
